"use client";

import { useEffect } from "react";

const ADSENSE_PUBLISHER_ID = process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID || "";

declare global {
  interface Window {
    adsbygoogle?: Array<Record<string, never>> & {
      requestNonPersonalizedAds?: number;
    };
  }
}

export function AdSenseScript() {
  useEffect(() => {
    if (!ADSENSE_PUBLISHER_ID || process.env.NODE_ENV === "development") {
      return;
    }
    if (document.querySelector('script[src*="adsbygoogle.js"]')) {
      return;
    }
    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_PUBLISHER_ID}`;
    document.head.appendChild(script);
  }, []);

  return null;
}
